import HTMLReactParser from "html-react-parser"
import moment from "moment"
import Link from "@components/anti/Link"
import SectionWithSlider from "@components/global/SectionWithSlider"
import { linkNewsroom } from "src/helper/page-url"
import { convertHtmlToReact, imgUrl } from "src/mixins"

function HomeNews({ data, locale }) {
  return (
    <SectionWithSlider
      sectionName="sc-home-news"
      data={data?.list?.map((item) => ({
        title: item[`title_${locale}`],
        text: moment(item.published_at).format("DD.MM.YYYY"),
        img: imgUrl(item.thumb_image),
        tags:
          item?.categories?.length && item?.categories[0][`title_${locale}`],
        linkCard: `${linkNewsroom}/${item?.slug}`,
      }))}
      title={data && data[`title_${locale}`]}
      text={
        <Link href={data.link_url} className="text-capitalize" withArrow>
          {convertHtmlToReact(data[`link_label_${locale}`])}
        </Link>
      }
      slidesPerViewMobile={1.2}
      slidesPerViewDesktop={1.6}
      cardType="boxless"
      hasArrow
    />
  )
}

export default HomeNews
